import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { fadeOutAnimation } from '../_animations/fade-out.animation';
import { AuthService } from './../auth/auth.service';

@Component({
    selector: 'ngbd-otp-sign-modal',
    template: `
    <div class="modal-header">
      <div class="modal-title">
        <fa-icon [icon]="['fas', 'pen-nib']" class="me-2"></fa-icon>{{ 'label.signering-med-engangskod' | translate }}
      </div>
    </div>
    <div class="modal-body">
      <p class="text-muted">{{ 'label.foljande-filer-signeras' | translate }}</p>
      <pre class="border rounded bg-light p-3 mb-3" [innerHTML]="filesToSign | join:'<br />'"></pre>
      <div class="input-group">
        <label class="otp-code text-center text-muted" for="otp">
          <input type="text" maxlength="6" required [(ngModel)]="otp" [style.background-color]="!otp ? '#fffa5c' : otp.length === 6 ? '#cafaca' : ''">
          {{ 'label.fyll-i-koden-du-fatt' | translate:{ recipient: recipient | lowercase } }}
        </label>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary btn-modal" (click)="ok()" [disabled]="!otp || otp.length < 6">{{ 'label.signera' | translate }}</button>
      <button type="button" class="btn btn-danger btn-modal" (click)="cancel()">{{ 'button.avbryt' | translate }}</button>
    </div>`,
    styles: [`
    .modal-title {
      font-size: 1rem;
    }
    .otp-code {
      padding: 1rem 0;
      width: 100%
    }
    .otp-code input {
      font-family: pt mono,SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace;
      font-size: 2.5rem;
      text-align: center;
      text-transform: uppercase;
      text-align: center;
      width: 100%;
    }
    label.otp-code {
      font-weight: 400 !important;
    }
    pre {
      font-size: 1rem;
    }
  `],
    animations: [
        fadeOutAnimation
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NgbdOtpSignModal {
  @Input() public requestId: string;
  @Input() public filesToSign: string[];
  @Input() public recipient: string;
  public otp: string;

  constructor(
    public activeModal: NgbActiveModal) {
  }

  public ok(): void {
    this.activeModal.close({ request: this.requestId, otp: this.otp });
  }

  public cancel(): void {
    this.activeModal.close();
  }
}
